
import React from 'react';
import { motion } from 'framer-motion';

export default function StatsSection() {
  const stats = [
    { value: '2350+', label: 'Tamamlanan Proje', icon: 'ri-building-2-line' },
    { value: '15+', label: 'Yıllık Deneyim', icon: 'ri-time-line' },
    { value: '50+', label: 'Uzman Ekip', icon: 'ri-team-line' },
    { value: '7/24', label: 'Teknik Destek', icon: 'ri-customer-service-line' },
  ];

  return (
    <section className="py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/912625c46b6ac5f319cc34d024274f15.jpg"
          alt="İstatistik arka plan"
          className="w-full h-full object-cover object-top"
        />
        {/* Overlay with dark opacity */}
        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className="text-center"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-red-500/20 rounded-xl mx-auto mb-4">
                <i className={`${stat.icon} text-2xl text-red-400`}></i>
              </div>
              <p className="text-4xl lg:text-5xl font-bold text-white mb-2">{stat.value}</p>
              <p className="text-white/60 text-sm">{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
